import Vue from 'vue'
import VueRouter from 'vue-router'
import { isMobile } from 'mobile-device-detect'
import auth from './modules/auth'
import dummy from './modules/dummy'
import vote from './modules/vote'
import other from './modules/other'
import middleware from './middleware'
import candidate from './modules/candidate'
// import getDataFromStorage from '@/helpers/getDataFromStorage'

// const { tokenCurrent } = getDataFromStorage()

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { path: '/login/tps' } },
    ...dummy,
    ...auth,
    ...vote,
    ...candidate,
    ...other,
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.meta.isMobile) {
    if (!isMobile) {
      return next('/error-404')
    }
  }
  if (to.meta.middleware) {
    const context = {
      to, from, next,
    }
    const middlewareOfMeta = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]
    return middleware(context, middlewareOfMeta)
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
